import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-builder-project',
  templateUrl: './skeleton-builder-project.component.html',
  styleUrls: ['./skeleton-builder-project.component.scss'],
  standalone: false
})
export class SkeletonBuilderProjectComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
